import { PARCEL_SOURCE_IDS, parcelHitLayersForSources } from './parcelSources';

/** Rendered parcel layers that answer a hit test, most specific first. */
export const PARCEL_HIT_LAYERS = parcelHitLayersForSources(PARCEL_SOURCE_IDS);

/** Land Records tiles vary by county, so fall back through the known id fields. */
export function parcelIdFromProperties(props) {
  const p = props || {};
  return p.lrid || p.parcelid || p.parcel_id || p.fid || p.id || null;
}

/** Normalize a queried tile feature into the payload the parcel UI expects. */
export function parcelFromFeature(feature) {
  if (!feature) return null;
  const props = feature.properties || {};
  return {
    parcelId: parcelIdFromProperties(props),
    properties: props,
    geometry: feature.geometry
  };
}

/** Parcel rendered under a screen point, or null. Ignores layers not yet added. */
export function parcelAtPoint(map, point) {
  if (!map || typeof map.queryRenderedFeatures !== 'function' || !point) return null;
  try {
    const layers = PARCEL_HIT_LAYERS.filter((id) => (map.getLayer ? map.getLayer(id) : true));
    if (!layers.length) return null;
    const feats = map.queryRenderedFeatures(point, { layers }) || [];
    return parcelFromFeature(feats[0]);
  } catch (_) {
    return null;
  }
}